import React, { Fragment } from 'react';
import NavbarContainer from 'shared/containers/NavbarContainer';
import AccountContainer from 'bundles/Account/containers/AccountContainer';

const AccountScene = (props) => {
    return (
        <Fragment>
            <NavbarContainer />
            <AccountContainer {...props} />
        </Fragment>
    );
};

export default AccountScene;
